import React from 'react'
import './Pricing.css'

const Pricing = () => {
  return (
    <section className="pricing section" id="pricing">
      <div className="container">
        <h2 className="section-title">Simple, Transparent Pricing</h2>
        <p className="section-subtitle">
          Choose the plan that works best for you
        </p>
        <div className="pricing-cards">
          <div className="pricing-card">
            <h3 className="pricing-tier">1 Month Plan</h3>
            <div className="pricing-price">
              <span className="price">€59</span>
              <span>/month</span>
            </div>
            <ul className="pricing-features">
              <li className="pricing-feature">Access for 1 month</li>
              <li className="pricing-feature">All core features</li>
              <li className="pricing-feature">Email support</li>
            </ul>
            <a href="#" className="btn btn-primary">
              Choose 1 Month
            </a>
          </div>

          <div className="pricing-card popular">
            <div className="popular-badge">Recommended</div>
            <h3 className="pricing-tier">3 Month Plan</h3>
            <div className="pricing-price">
              <span className="price">€149</span>
              <span>/3 months</span>
            </div>
            <ul className="pricing-features">
              <li className="pricing-feature">Access for 3 months</li>
              <li className="pricing-feature">
                Most people need around 3 months to find their dream home
              </li>
              <li className="pricing-feature">All core features</li>
              <li className="pricing-feature">Priority support</li>
            </ul>
            <a href="#" className="btn btn-primary">
              Choose 3 Months
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Pricing
